import ActionLink from './ActionLink';
import { ChevronLeftSvg } from '@/assets/Icons';

// import { SourcePageTrackerContext } from '../../context/sourcePageTracker/sourcePageTrackerProvider';

interface MoreButtonProps {
    descriptiveText?: string;
    to: string;
    onClick?: () => void;
}

const MoreButton = ({ descriptiveText, to = '', onClick }: MoreButtonProps) => {
    return (
        <ActionLink
            to={to}
            alt={descriptiveText}
            aria-label={descriptiveText}
            onClick={onClick}
            className="entity-list-show-more">
            بیشتر
            <ChevronLeftSvg className="entity-list-show-more-icon" />
        </ActionLink>
    );
};

export default MoreButton;
